const PM_ICONS = [
  { src: "/assets/pm-icons/01-bypassing-safety-controls.png", label: "Bypassing Safety Controls" },
  { src: "/assets/pm-icons/02-confined-space.png", label: "Confined Space" },
  { src: "/assets/pm-icons/03-driving.png", label: "Driving" },
  { src: "/assets/pm-icons/04-energy-isolation.png", label: "Energy Isolation" },
  { src: "/assets/pm-icons/05-fire-safety.png", label: "Fire Safety" },
  { src: "/assets/pm-icons/06-line-of-fire.png", label: "Line of Fire" },
  { src: "/assets/pm-icons/07-lifting-operations.png", label: "Lifting Operations" },
  { src: "/assets/pm-icons/08-work-authorisation.png", label: "Work Authorisation" },
  { src: "/assets/pm-icons/09-working-at-height.png", label: "Working at Height" },
];

export default function PMIconCarousel() {
  const step = 360 / PM_ICONS.length;
  return (
    <div data-testid="pm-icon-carousel">
      <div className="pm-ring-stage" role="img" aria-label="Safety rule icons rotating carousel">
        <div className="pm-ring">
          {PM_ICONS.map((icon, i) => (
            <div
              key={icon.src}
              className="pm-ring-item"
              data-testid={`pm-icon-carousel-item-${icon.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              style={{ transform: `rotateY(${i * step}deg) translateZ(var(--pm-ring-radius))` }}
            >
              <img src={icon.src} alt={icon.label} title={icon.label} loading="lazy" className="h-full w-full" />
            </div>
          ))}
        </div>
      </div>
      <p data-testid="pm-icon-carousel-title" className="mt-1 text-center font-display text-lg sm:text-xl font-bold text-navy">
        100% adherence to pinpointed Life Saving Rules
      </p>
    </div>
  );
}
